"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var hoursMinutesSeconds_i18n_1 = require("./hoursMinutesSeconds.i18n");
var useLocalisation_1 = require("../../hooks/useLocalisation");
function hoursMinutesSeconds(value, language) {
    var formatted = "";
    var strings = useLocalisation_1.getLocalisation(hoursMinutesSeconds_i18n_1.hoursMinutesSecondsTranslations, language);
    if (value === undefined) {
        formatted = "";
    }
    else if (value < 0) {
        formatted = "0";
    }
    else {
        var hours = Math.floor(value / 3600);
        var minutes = Math.floor((value - hours * 3600) / 60);
        if (minutes >= 60) {
            minutes -= 60;
            hours++;
        }
        var seconds = value < 0.5 && value > 0 ? 1 : Math.round(value - hours * 3600 - minutes * 60);
        if (seconds >= 60) {
            seconds -= 60;
            minutes++;
        }
        if (minutes >= 60) {
            minutes -= 60;
            hours++;
        }
        if (seconds || (!hours && !minutes)) {
            formatted = "" + seconds + strings.seconds;
        }
        if (minutes || (hours && seconds)) {
            formatted = "" + minutes + strings.minutes + " " + formatted;
        }
        if (hours) {
            formatted = "" + hours + strings.hours + " " + formatted;
        }
    }
    return formatted.trim();
}
exports.hoursMinutesSeconds = hoursMinutesSeconds;
